import { tKey, type I18nKey } from "@/core/i18n";
import {
  EvalGpioStateEnum,
  EvalLimitItemEdgeEnum,
  EvalLimitItemParameterEnum,
  EvalLimitItemQuantifierTypeEnum,
  EvalLimitItemQuantifierUnitEnum,
  type EvalGpioAction,
} from "@repo/schema";
import type { TFunction } from "i18next";

export const quantifierTypeLabel = {
  [EvalLimitItemQuantifierTypeEnum.MIN]: tKey("evaluation:quantifierType.MIN"),
  [EvalLimitItemQuantifierTypeEnum.MAX]: tKey("evaluation:quantifierType.MAX"),
  [EvalLimitItemQuantifierTypeEnum.EXACT]: tKey("evaluation:quantifierType.EXACT"),
} satisfies Record<EvalLimitItemQuantifierTypeEnum, I18nKey<"evaluation">>;

export const quantifierUnitLabel = {
  [EvalLimitItemQuantifierUnitEnum.PERCENT]: tKey("evaluation:quantifierUnit.PERCENT"),
  [EvalLimitItemQuantifierUnitEnum.PCS]: tKey("evaluation:quantifierUnit.PCS"),
} satisfies Record<EvalLimitItemQuantifierUnitEnum, I18nKey<"evaluation">>;

export const parameterLabel = {
  [EvalLimitItemParameterEnum.POSITION]: tKey("evaluation:parameter.POSITION"),
  [EvalLimitItemParameterEnum.AREA]: tKey("evaluation:parameter.AREA"),
  [EvalLimitItemParameterEnum.COUNT]: tKey("evaluation:parameter.COUNT"),
} satisfies Record<EvalLimitItemParameterEnum, I18nKey<"evaluation">>;

export const parameterUnit = {
  [EvalLimitItemParameterEnum.COUNT]: tKey("evaluation:parameterUnit.COUNT"),
  [EvalLimitItemParameterEnum.AREA]: tKey("evaluation:parameterUnit.AREA"),
  [EvalLimitItemParameterEnum.POSITION]: tKey("evaluation:parameterUnit.POSITION"),
} satisfies Record<EvalLimitItemParameterEnum, I18nKey<"evaluation">>;

export const edgeLabel = {
  [EvalLimitItemEdgeEnum.LEFT]: tKey("evaluation:edge.LEFT"),
  [EvalLimitItemEdgeEnum.RIGHT]: tKey("evaluation:edge.RIGHT"),
  [EvalLimitItemEdgeEnum.TOP]: tKey("evaluation:edge.TOP"),
  [EvalLimitItemEdgeEnum.BOTTOM]: tKey("evaluation:edge.BOTTOM"),
  [EvalLimitItemEdgeEnum.CENTER]: tKey("evaluation:edge.CENTER"),
} satisfies Record<EvalLimitItemEdgeEnum, I18nKey<"evaluation">>;

export const gpioStateLabel = {
  [EvalGpioStateEnum.HIGH]: tKey("evaluation:gpioState.HIGH"),
  [EvalGpioStateEnum.LOW]: tKey("evaluation:gpioState.LOW"),
  [EvalGpioStateEnum.TOGGLE]: tKey("evaluation:gpioState.TOGGLE"),
} satisfies Record<EvalGpioStateEnum, I18nKey<"evaluation">>;

/**
 * A null duration latches the pin until something else changes it; a value
 * pulses and then reverts the pin to the level it held before.
 */
export function formatGpioAction(
  action: EvalGpioAction,
  t: TFunction<["evaluation", "common"]>,
): string {
  const { pin, durationMs } = action;
  const state = t(gpioStateLabel[action.state]);
  return durationMs === null
    ? t("evaluation:gpio.summaryLatch", { pin, state })
    : t("evaluation:gpio.summaryPulse", { pin, state, durationMs });
}
